import { AIU_DEFINITION } from '../metricInfo';
import { MiniGauge, type GaugeBand } from './EfficiencyGauge';
import { InfoTooltip, Term } from './InfoTooltip';

export function KpiCard({
  label,
  value,
  unit,
  meta,
  hero,
  flag,
  info,
  accentClassName = 'bg-primary-blue',
  gauge,
}: {
  label: string;
  value: string;
  unit?: string;
  meta?: string;
  hero?: boolean;
  flag?: string;
  info?: string;
  accentClassName?: string;
  /** Adds a centered meter with its score below, for a percentage where higher (or lower) is better. */
  gauge?: { value: number | null; bands?: GaugeBand[]; higherIsBetter?: boolean };
}) {
  return (
    <div className={`relative rounded-card border border-border bg-surface p-5 shadow-sm ${hero ? 'sm:col-span-2' : ''}`}>
      <span className={`absolute inset-y-0 left-0 w-[3px] rounded-l-card ${accentClassName}`} />
      <p className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide text-text-muted">
        {label}
        {info && <InfoTooltip text={info} />}
        {flag && (
          <span className="rounded bg-warn-bg px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-warn-ink">
            {flag}
          </span>
        )}
      </p>
      {gauge ? (
        <div className="mt-2">
          <MiniGauge
            label={label}
            value={gauge.value}
            bands={gauge.bands}
            higherIsBetter={gauge.higherIsBetter}
            prominent
            score={`${value}${unit === '%' ? '%' : unit ? ` ${unit}` : ''}`}
          />
        </div>
      ) : (
        <p className={`font-bold text-text-default ${hero ? 'text-[42px]' : 'text-[32px]'} leading-tight`}>
          {value}
          {unit && (
            <span className="ml-1 text-base font-medium text-text-muted">
              {unit === 'AIU' ? <Term title={AIU_DEFINITION}>AIU</Term> : unit}
            </span>
          )}
        </p>
      )}
      {meta && <p className="mt-1.5 text-xs text-text-muted">{meta}</p>}
    </div>
  );
}
